import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Portal, Root } from '@radix-ui/react-dialog';
import type { Variants } from 'framer-motion';
import { motion } from 'framer-motion';
import { faArrowUpLong } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import { Button } from '@components/main-components/button/Button';
import { DataTestId } from '@utils/test';

export const MOBILE_POPUP_BUTTON_OFFSET = 76;
export const TABLET_POPUP_BUTTON_OFFSET = 10;
export const AUDIO_PLAYING_MOBILE_POPUP_BUTTON_OFFSET = 136;
export const AUDIO_PLAYING_TABLET_POPUP_BUTTON_OFFSET = 103;

export const PopupButton = ({
  dataTestId,
  bottom = 10,
  onClick,
  loading,
  label,
  isVisible,
}: {
  dataTestId?: string;
  bottom?: number;
  onClick?: () => void;
  loading?: boolean;
  label: string;
  isVisible: boolean;
}) => {
  const animationVariants: Variants = {
    reveal: {
      opacity: 1,
      bottom: bottom,
    },
    hide: {
      opacity: 0,
      bottom: bottom - 100,
    },
  };

  return (
    <Root open>
      <Portal>
        <motion.div
          className="fixed z-above2 flex w-full items-center justify-center will-change-[bottom] "
          animate={isVisible ? 'reveal' : 'hide'}
          variants={animationVariants}
          initial="hide"
          transition={{ type: 'spring', stiffness: 100, delay: 1 }}
          data-testid={DataTestId.POPUP_BUTTON_WRAPPER}
        >
          <Button
            testId={dataTestId}
            label={label}
            leadingIcon={loading ? null : <FontAwesomeIcon icon={faArrowUpLong} />}
            variant="primary"
            size="M"
            className="h-8 rounded-xl text-base-s md:text-base-m"
            onClick={onClick}
            loading={loading}
          />
        </motion.div>
        <span className="fixed left-1/2 h-5 w-5 translate-x-1/2" id="rewardId" style={{ bottom }} />
      </Portal>
    </Root>
  );
};
